module.exports = __webpack_public_path__ + "img/banker-purple_600.46b8b784.png";